import AdaliaMEDatagridBase from "./adalia_me_datagrid_base.jsx";

import { datagrid_list_json_path } from '~/routes';

export default class AdaliaMEDatagrid extends AdaliaMEDatagridBase {
    static get TYPE() {
        return "adalia_me_datagrid";
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.props.pdf) return;

        jQuery.getJSON(datagrid_list_json_path({programme_form_id: this.context.programmeFormId, _options: true}), (data) => {
          this.setState({
            datagrids: data,
            context_name: 'datagrid'
          })
        });
    }
}